module.exports = __webpack_public_path__ + "static/item_sort_order_example-a52e5cb742bc054fe449685fa0e687f7.png";